<template>
  <div ref="snapshot">
    <canvas ref="canvas"></canvas>
  </div>
</template>


<script>
export default {
  name: "EventTrackSnapshot",
  props: {
    image: String,
    fences: {
      type: Array,
      default: () => [],
    },
    objects: {
      type: Array,
      default: () => [],
    },
    width: Number,
    height: Number,
    maxWidth: Number,
    maxHeight: Number,
  },
  mounted() {
    this.setStyle();
    this.drawCanvas();
  },
  watch: {
    image() {
      this.drawCanvas();
    },
    fences: {
      handler: function () {
        this.drawCanvas();
      },
      deep: true,
    },
    objects: {
      handler: function () {
        this.drawCanvas();
      },
      deep: true,
    },
    height() {
      this.drawCanvas();
    },
    width() {
      this.drawCanvas();
    },
  },
  methods: {
    setStyle() {
      let canvas = this.$refs.canvas;
      canvas.style.width = "100%";

      if (this.width != undefined) {
        canvas.style.width = this.width + "px";
      }
      if (this.height != undefined) {
        canvas.style.height = this.height + "px";
      }
      if (this.maxWidth != undefined) {
        canvas.style.maxWidth = this.maxWidth + "px";
      }
      if (this.maxHeight != undefined) {
        canvas.style.maxHeight = this.maxHeight + "px";
      }
    },
    drawFences(canvas, fences, width, height) {
      let context = canvas.getContext("2d");

      context.strokeStyle = "#0021DA"; //set fence color
      context.fillStyle = "#0021DA"; //set font color

      if (canvas.height < 500 || canvas.width < 500) {
        context.lineWidth = 3;
        context.font = "bold 14px Arial";
      } else {
        context.lineWidth = 5;
        context.font = "bold 20px Arial";
      }

      fences.forEach((fence) => {
        if (fence.type == "FenceBox") {
          //Begin drawing fenceBox
          context.beginPath();

          context.fillText(
            fence.name,
            fence.min.x * width + 10,
            fence.min.y * height + 20
          );

          context.strokeRect(
            fence.min.x * width,
            fence.min.y * height,
            (fence.max.x - fence.min.x) * width,
            (fence.max.y - fence.min.y) * height
          );

          context.closePath();
          context.stroke();
        } else if (fence.type == "FencePolygon") {
          //Begin drawing fencePolygon
          context.beginPath();

          context.fillText(
            fence.name,
            fence.points[0].x * width + 10,
            fence.points[0].y * height + 20
          );

          context.moveTo(fence.points[0].x * width, fence.points[0].y * height);
          for (let i = 1; i < fence.points.length; i++) {
            context.lineTo(
              fence.points[i].x * width,
              fence.points[i].y * height
            );
          }

          context.closePath();
          context.stroke();
        } else if (fence.type == "FenceLine") {
          //Begin drawing fenceLine
          context.beginPath();

          context.fillText(
            fence.name,
            fence.p1.x * width + 10,
            fence.p1.y * height + 20
          );

          context.moveTo(fence.p1.x * width, fence.p1.y * height);
          context.lineTo(fence.p2.x * width, fence.p2.y * height);

          context.closePath();
          context.stroke();
        }
      });
    },
    drawObjects(canvas, objects, width, height) {
      let context = canvas.getContext("2d");

      context.strokeStyle = "#EBE64E"; //set box color
      context.fillStyle = "#EBE64E"; //set font color

      if (canvas.height < 500 || canvas.width < 500) {
        context.lineWidth = 3;
        context.font = "bold 14px Arial";
      } else {
        context.lineWidth = 5;
        context.font = "bold 20px Arial";
      }

      objects.forEach((object) => {
        //Begin drawing fenceBox
        context.beginPath();

        context.strokeRect(
          object.coordinate.top.x * width,
          object.coordinate.top.y * height,
          (object.coordinate.bottom.x - object.coordinate.top.x) * width,
          (object.coordinate.bottom.y - object.coordinate.top.y) * height
        );
        context.closePath();
        context.stroke();
      });
    },
    drawCanvas() {
      this.$nextTick(function () {
        let canvas = this.$refs.canvas;
        let context = canvas.getContext("2d");
        let image = new Image();
        let fences = this.fences;
        let objects = this.objects;

        image.src = this.image;

        let snapshot = this;
        image.onload = function () {
          let w = this.width;
          let h = this.height;
          canvas.width = w;
          canvas.height = h;

          context.clearRect(0, 0, w, h);
          context.drawImage(this, 0, 0, w, h);

          snapshot.drawFences(canvas, fences, w, h);
          snapshot.drawObjects(canvas, objects, w, h);
        };
      });
    },
  },
};
</script>